import { render, staticRenderFns } from "./DrawerList.vue?vue&type=template&id=36b6ef09"
import script from "./DrawerList.vue?vue&type=script&lang=js"
export * from "./DrawerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports